import { createFileRoute } from "@tanstack/react-router"
import { SignupForm } from "@/components/ui/auth/SignupForm"

type SignupSearch = {
  role?: string
}

export const Route = createFileRoute("/signup")({
  validateSearch: (search: Record<string, unknown>): SignupSearch => {
    return {
      role: (search.role as string) || undefined,
    }
  },
  component: SignupPage,
})

function SignupPage() {
  return <SignupForm />
}
